import Nullstack from 'nullstack';
export default function IconRollercoaster({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-rollercoaster",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M3 21a5.55 5.55 0 0 0 5.265 -3.795l.735 -2.205a8.775 8.775 0 0 1 8.325 -6h3.675"
  }), "   ", Nullstack.element("path", {
    d: "M20 9v12"
  }), "   ", Nullstack.element("path", {
    d: "M8 21v-3"
  }), "   ", Nullstack.element("path", {
    d: "M12 21v-10"
  }), "   ", Nullstack.element("path", {
    d: "M16 9.5v11.5"
  }), "   ", Nullstack.element("path", {
    d: "M15 3h5v3h-5z"
  }), "   ", Nullstack.element("path", {
    d: "M6 8l4 -3l2 2.5l-4 3l-1.8 -.5z"
  }), " ");
}